export default __webpack_public_path__ + "static/media/live-icon.c20dbc29.webp";